export default {
    addSupport: ({ commit }, supportToAdd) => new Promise((resolve) => {
        commit('updateSupport', supportToAdd);
        resolve(supportToAdd);
    }),
    updateSupport: ({ commit }, supportToUpdate) => new Promise((resolve) => {
        commit('updateSupport', supportToUpdate);
        resolve(supportToUpdate);
    }),
    removeSupport: ({ commit }, supportToRemove) => new Promise((resolve) => {
        commit('removeSupport', supportToRemove);
        resolve(supportToRemove);
    }),
};



// WEBPACK FOOTER //
// ./src/store/modules/Support/actions.js